"use client";

import { signIn } from "next-auth/react";
import { useStoreSelector } from "@workspace/core";
import { observer } from "mobx-react-lite";
import { TrainingLoader } from "@workspace/ui/common";
import { useEffect } from "react";
import { when } from "mobx";

function SignIn() {
  const authStore = useStoreSelector((store) => store.auth);
  const workspaceStore = useStoreSelector((store) => store.workspace);

  useEffect(() => {
    const authDispose = when(
      () => authStore.status === "unauthenticated",
      () => {
        void signIn("keycloak");
      },
    );

    const workspaceDispose = when(
      () => {
        return workspaceStore.isWorkspaceReady;
      },
      () => {
        if (
          workspaceStore.workspaces!.some(
            (workspace) => workspace.role === "admin",
          )
        ) {
          window.location.href = `${process.env.NEXT_PUBLIC_ADMIN_URL}/admin`;
          return;
        }

        return (window.location.href = `${process.env.NEXT_PUBLIC_ADMIN_URL}/dashboard`);
      },
    );

    return () => {
      authDispose();
      workspaceDispose();
    };
  }, [authStore, workspaceStore]);

  return <TrainingLoader />;
}

const _SignIn = observer(SignIn);
export default _SignIn;
